export enum IntentStatus {
    NEW = 'NEW',
    INVALID_GRAMMAR = 'INVALID_GRAMMAR',
    OK = 'OK',
}

export interface GrammarIntentFlags {
    isActivation: boolean;
}

export interface GrammarIntentShort extends GrammarIntentFlags {
    id: string;
    humanReadableName: string;
    status: IntentStatus;
}

export interface GrammarIntentEditableFields {
    humanReadableName: string;
    formName: string;
    sourceText: string;
    positiveTests: string;
    negativeTests: string;
}
export type GrammarIntent = GrammarIntentEditableFields & GrammarIntentShort;

interface SingleTestResult {
    text: string;
}

export interface GrammarIntentTestResult {
    precision: number;
    recall: number;
    truePositives: SingleTestResult[];
    trueNegatives: SingleTestResult[];
    falsePositives: SingleTestResult[];
    falseNegatives: SingleTestResult[];
}

export const emptyGrammarIntentSettings: GrammarIntentEditableFields = {
    formName: '',
    humanReadableName: '',
    sourceText: '',
    positiveTests: '',
    negativeTests: '',
};

export interface GrammarValidationErrorBounds {
    lineNumber: number;
    charOffset: number;
    charCount: number;
}

export type GrammarValidationErrorPayload =
    | {
          errorCode: 'VALIDATION_ERROR';
          errorBounds: GrammarValidationErrorBounds;
          text: string;
      }
    | {
          errorCode: 'GRAMMAR_SIZE_LIMIT';
          text: string;
      };
